import { useCallback, useState } from "react";
import { getVisitorById } from "../api/visitorsApi";
import { safeErrorText } from "../utils/visitorHelpers";

/** Load visitor for inline edit and scroll to the form panel (call-logs pattern). */
export function useVisitorInlineEdit(editPanelId = "visitor-register") {
  const [editingVisitor, setEditingVisitor] = useState(null);
  const [editError, setEditError] = useState("");

  const openEdit = useCallback(async (row) => {
    const id = row?.id;
    if (!id) return;
    setEditError("");
    try {
      const res = await getVisitorById(id);
      const visitor = res?.data;
      if (!visitor?.id) throw new Error("Unable to load visitor for editing");
      setEditingVisitor(visitor);
      requestAnimationFrame(() => {
        document.getElementById(editPanelId)?.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    } catch (err) {
      setEditError(safeErrorText(err, "Failed to open visitor for editing"));
    }
  }, [editPanelId]);

  const openEditById = useCallback(
    async (id) => {
      if (!id) return;
      await openEdit({ id });
    },
    [openEdit],
  );

  const cancelEdit = useCallback(() => {
    setEditingVisitor(null);
    setEditError("");
    requestAnimationFrame(() => {
      document
        .getElementById("visitor-list")
        ?.scrollIntoView({ behavior: "smooth", block: "start" });
      document
        .getElementById("visitor-control-list")
        ?.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  }, []);

  return {
    editingVisitor,
    editError,
    setEditError,
    openEdit,
    openEditById,
    cancelEdit,
    clearEdit: () => setEditingVisitor(null),
  };
}
